import { z } from 'zod';
/**
 * Outbound — the closed set of delivery channels LeanOpx ships a briefing
 * through. Most users read the morning briefing in their inbox or Slack,
 * not in the LeanOpx app; the iOS push is the lockscreen surface for the
 * subset that drives the day off their phone.
 *
 * Phase 7 of Epic #123 ships the **preview** for these three surfaces —
 * `/outbound/preview` renders the same `Briefing` through three pure-
 * presentation channel renderers so operators can see exactly how the
 * day's briefing will appear when delivered. The actual delivery wiring
 * (SendGrid for email, Slack Web API for DM, APNs for iOS push) is
 * deferred and tracked at Epic #123's open-questions list.
 *
 * Promoted to a closed-set enum (vs the literal-string union the design
 * doc carried) so the surface, future delivery dispatcher, and audit
 * trail all reference one source of truth. Every call site uses
 * `OutboundChannel.enum.<key>` rather than the bare string.
 */
export const OutboundChannel = z.enum(['email', 'slack-dm', 'ios-push']);
